<template>
    <v-card-text style="flex-grow: 1; overflow-y: auto" ref="list">
        <v-row class="ma-n4">
            <template v-for="(message, index) in messages">
                <messages-item v-bind="{ index, message, isScrollFixed }" v-on="{ scroll }" :key="index" />
            </template>
        </v-row>
    </v-card-text>
</template>

<script>
import { mapState } from "vuex";
import MessagesItem from "./messages/messages-item.vue";

export default {
    components: {
        MessagesItem,
    },
    data: () => ({
        isInitiated: false,
        isScrollFixed: true,
    }),
    computed: {
        ...mapState("lecture/chat", ["messages"]),
    },
    methods: {
        init() {
            if (!this.isInitiated) {
                const intervalId = setInterval(() => {
                    const el = this.$refs["list"];
                    if (!el) return;

                    el.addEventListener("scroll", this.onScroll);
                    el.scrollTop = el.scrollHeight;
                    this.isInitiated = true;

                    clearInterval(intervalId);
                }, 10);
            }
        },
        onScroll(event) {
            const { scrollHeight, scrollTop, clientHeight } = event.target;
            this.isScrollFixed = scrollHeight - (scrollTop + clientHeight) < 30;
        },
        scroll() {
            const el = this.$refs["list"];
            if (!el) return;
            el.scrollTo({ top: el.scrollHeight });
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
</style>
